import {
  CHANGE_INITIAL_LOADED,
  CLEAR_SEARCH_LIST_PROFILE,
  FETCH_SEARCH_LIST_PROFILE,
  SearchListProfileTypes,
} from 'actions/search/searchListProfileAction'
import {
  RestoreInitialStateAction,
  RESTORE_INITIAL_STATE,
} from 'actions/system/restoreInitialStateAction'
import { ProfileItem, SearchListApi } from 'api/search/search.types'
import {
  DEFAULT_SEARCH_LIMIT,
  mapFaceCoordsToItems,
} from 'components/page/Search/searchPromoFunctions'
import { initialStateReducer } from 'reducers/default/initialStateReducer'
import { defaultPromiseReducer } from 'reducers/defaultPromiseReducer'
import { injectSearchResultProfile } from 'reducers/search/mainSeachReducer.functions'
import {
  initialState,
  SearchListProfileState,
} from 'reducers/search/SearchListProfileState'

export const searchListProfileReducer = (
  state = initialState,
  action: SearchListProfileTypes | RestoreInitialStateAction
): SearchListProfileState => {
  switch (action.type) {
    case FETCH_SEARCH_LIST_PROFILE:
      return defaultPromiseReducer<SearchListProfileState, SearchListApi>(
        state,
        action,
        () => ({
          resultLoading: true,
          resultLoaded: false,
        }),
        (result) => {
          const items = result.items.map((item) => ({
            ...item,
            cursor: action.cursor,
          }))

          const selectedIndexProfile = items.findIndex(
            ({ aid }: ProfileItem) => aid === Number(action.userId)
          )

          const listWithoutSelectedProfile = items.slice(
            selectedIndexProfile + 1
          )

          return {
            resultLoading: false,
            resultLoaded: true,
            ...injectSearchResultProfile(
              mapFaceCoordsToItems(
                listWithoutSelectedProfile,
                result.faceCoordinates
              ),
              result,
              state,
              action.promos!
            ),
            isEnd: result.items.length < DEFAULT_SEARCH_LIMIT,
            cursor: result.cursor,
          }
        },
        () => ({
          resultLoading: false,
          resultLoaded: true,
          isEnd: true,
        })
      )

    case CHANGE_INITIAL_LOADED:
      return {
        ...state,
        initialLoaded: true,
      }

    case CLEAR_SEARCH_LIST_PROFILE:
      return {
        ...initialState,
      }

    case RESTORE_INITIAL_STATE:
      return initialStateReducer(state, action, 'searchListProfile')

    default:
      return state
  }
}
